import { LandingFooter } from "@/components/landing/shared";
import "@/components/marketing/marketing.css";

/**
 * The marketing footer for the public org pages. It needs the `.mk` scope for
 * its tokens and container queries; `mk-app__foot` drops `.mk`'s full-height
 * minimum so the wrapper is only as tall as the footer.
 */
export default function PublicOrgFooter() {
  return (
    <div className="mk mk-app__foot">
      <LandingFooter appearance="marketing" />
    </div>
  );
}
